import * as THREE from 'three'
import type { GSplatVector3Input } from './effectUtils'
import { createVector3 } from './effectUtils'
import type { GSplatShaderEffectOptions } from './GSplatShaderEffect'
import { GSplatShaderEffect } from './GSplatShaderEffect'

export interface GSplatRevealShowcaseEffectOptions extends GSplatShaderEffectOptions {
  center?: GSplatVector3Input
  timeScale?: number
  motionScale?: number
  duration?: number
}

export interface GSplatRevealShowcaseEffectConfig {
  id: string
  shader: string
  shaderWGSL?: string
}

export abstract class GSplatRevealShowcaseEffect extends GSplatShaderEffect {
  private readonly _center: THREE.Vector3
  private readonly _timeScale: number
  private readonly _motionScale: number
  private readonly _duration: number
  private readonly _shader: string
  private readonly _shaderWGSL: string | null

  protected constructor(
    config: GSplatRevealShowcaseEffectConfig,
    options: GSplatRevealShowcaseEffectOptions = {}
  ) {
    super({
      ...options,
      id: options.id ?? config.id,
    })

    this._center = createVector3(options.center, new THREE.Vector3())
    this._timeScale = options.timeScale ?? 1
    this._motionScale = options.motionScale ?? 1
    this._duration = Math.max(0.001, options.duration ?? 6)
    this._shader = config.shader
    this._shaderWGSL = config.shaderWGSL ?? null
  }

  override getShaderGLSL(): string {
    return this._shader
  }

  override getShaderWGSL(): string | null {
    return this._shaderWGSL
  }

  protected override updateEffect(effectTime: number): void {
    this.setUniform('uTime', effectTime)
    this.setUniform('uTimeScale', this._timeScale)
    this.setUniform('uMotionScale', this._motionScale)
    this.setUniform('uDuration', this._duration)
    this.setUniform('uCenter', this._center)
  }
}
